import { FunctionComponent, useEffect, useMemo, useState } from 'react'
import useStyles from './styles'
import { AvatarProps } from './types'
import { useValidateProps } from './utils'
import AvatarFallback from '@/assets/avatar-fallback.svg'

export const Avatar: FunctionComponent<AvatarProps> = ({
  alt,
  styles: overrides,
  src,
  size: sizeProp = 'sm',
  imgProps,
  hasNotifications,
  label,
}) => {
  const { size } = useValidateProps({ sizeProp })
  const [imgError, setImgError] = useState(false)
  const styles = useStyles({ size })

  useEffect(() => {
    setImgError(false)
  }, [src])

  const currentSrc = useMemo(() => {
    if (imgError || !src) return AvatarFallback
    return src
  }, [src, imgError])

  return (
    <div css={[styles.root, overrides?.root]}>
      <div css={[styles.avatar, overrides?.avatar]}>
        {hasNotifications && (
          <span css={[styles.notification, overrides?.notification]} />
        )}

        <img
          data-testid="hero-avatar"
          {...imgProps}
          css={[styles.image, overrides?.image]}
          src={currentSrc}
          alt={alt}
          onError={() => setImgError(true)}
        />
      </div>
      {label && <span css={[styles.label, overrides?.label]}>{label}</span>}
    </div>
  )
}
